import { compose, setDisplayName, withProps } from 'recompose';

import {
  KEY_BUTTON_BACKGROUND_COLOR_KEY,
  KEY_BUTTON_BORDER_COLOR_KEY,
  KEY_BUTTON_BORDER_RADIUS_KEY,
  KEY_BUTTON_BORDER_STYLE_KEY,
  KEY_BUTTON_BORDER_WIDTH_KEY,
  KEY_BUTTON_FONT_COLOR_KEY,
  KEY_BUTTON_FONT_SIZE_KEY,
  KEY_BUTTON_FONT_STYLE_KEY,
  KEY_BUTTON_FONT_WEIGHT_KEY,
  KEY_BUTTON_TEXT_DECORATION_KEY,
  KEY_BUTTON_TEXT_TRANSFORM_KEY,
} from '../../const/keysBlockStyling';

const StylingToCSSButton = withProps(
  ({
    styling: {
      [KEY_BUTTON_BACKGROUND_COLOR_KEY]: backgroundColor,
      [KEY_BUTTON_BORDER_COLOR_KEY]: borderColor,
      [KEY_BUTTON_BORDER_RADIUS_KEY]: borderRadius,
      [KEY_BUTTON_BORDER_STYLE_KEY]: borderStyle,
      [KEY_BUTTON_BORDER_WIDTH_KEY]: borderWidth,
      [KEY_BUTTON_FONT_COLOR_KEY]: color,
      [KEY_BUTTON_FONT_SIZE_KEY]: fontSize,
      [KEY_BUTTON_FONT_STYLE_KEY]: fontStyle,
      [KEY_BUTTON_FONT_WEIGHT_KEY]: fontWeight,
      [KEY_BUTTON_TEXT_DECORATION_KEY]: textDecoration,
      [KEY_BUTTON_TEXT_TRANSFORM_KEY]: textTransform,
    } = {},
  }) => ({
    inputCSS: {
      color,
      fontSize,
      fontWeight,
      fontStyle,
      textDecoration,
      textTransform,
    },
    buttonCSS: {
      backgroundColor,
      borderColor,
      borderRadius,
      borderStyle,
      borderWidth,
    },
  }),
);

export default compose(
  setDisplayName('StylingToCSSButton'),
  StylingToCSSButton,
);
